import { Box, Container, Divider, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'react-i18next'
import Header from '../../../../shared/components/Header'
import CardHero from '../../../../shared/components/frontoffice/CardHero'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'
import useSkeleton from '../../../../shared/components/layouts/SkeletonLayout'
import ContentFilter from '../../../../shared/components/layouts/filters/ContentFilter'
import SubHeader from '../../../../shared/styles/Subheader'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import HighlightNewsCarousel from '../components/HighlightNewsCarousel'
import NewsFrontNotifications from '../components/NewsFrontNotifications'
import { useNewsData } from '../hooks/useNewsData'
dayjs.extend(relativeTime)

function NewsPanel() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const { highlightNews, noHighlightNews, cutContent, handleFavoriteClick } = useNewsData()
  const { loading: loadingSkeleton, component: componentSkeleton } = useSkeleton()

  if (loadingSkeleton) {
    return <>{componentSkeleton}</>
  }

  return (
    <>
      <Header title={t('news')} />
      <SubHeader />
      <ContentFilter goBackAction={true} />

      <Container sx={{ maxWidth: 1008 }}>
        <Grid
          container
          spacing={2}
          sx={isMobile ? { justifyContent: 'center', paddingX: 1 } : { maxWidth: 900, margin: '0 auto', justifyContent: 'center' }}
        >
          <HighlightNewsCarousel highlightNews={highlightNews} cutContent={cutContent} />
          <Box sx={{ display: 'flex', alignItems: 'center', py: 1, pb: 2, width: 1008 }}>
            <Typography variant="h6" sx={{ minWidth: 'max-content' }}>
              {t('last-news')}
            </Typography>
            <Divider style={{ marginLeft: 16, flexShrink: 1 }} />
          </Box>
          <Grid container spacing={2} sx={isMobile ? {} : { maxWidth: 900, margin: '0 auto' }}>
            {noHighlightNews.map((currentNews: any) => (
              <Grid key={currentNews.id} item xs={12} lg={4}>
                <CardHero
                  type={1}
                  redirect={`/noticias/${currentNews.slug}`}
                  cardBrandName={currentNews.brand?.name || ''}
                  cardVisibility={currentNews.visibility}
                  cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
                  cardTitle={currentNews.title}
                  cardDescription={<div dangerouslySetInnerHTML={{ __html: cutContent(currentNews.content) }} />}
                  cardDate={`${dayjs(currentNews.created_at).fromNow()}`}
                  cardActions={
                    <ShareIcon
                      visibility={currentNews.visibility}
                      title={currentNews.title}
                      description={currentNews.title}
                      link={`${window.location.origin}/noticias/${currentNews.slug}${window.location.search}`}
                      type="news"
                      multimedia={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
                      buttonText={t('share')}
                    />
                  }
                  favoriteState={Boolean(currentNews.favoriteId)}
                  onClickFavorite={handleFavoriteClick(currentNews.id)}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>

      <NewsFrontNotifications />
    </>
  )
}

export default NewsPanel
